import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { API_BASE } from '../lib/api';

import logger from '../lib/logger';
const genSessionId = () => {
  try {
    let s = sessionStorage.getItem('ld_session');
    if (!s) {
      s = 'ld-' + Math.random().toString(36).slice(2, 12) + '-' + Date.now().toString(36);
      sessionStorage.setItem('ld_session', s);
    }
    return s;
  } catch (e) {
    logger.warn('[visitor-track] sessionStorage unavailable, using ephemeral id:', e);
    return 'anon-' + Date.now();
  }
};

const useVisitorTracking = (region = 'global', language = 'en') => {
  const { pathname } = useLocation();

  useEffect(() => {
    let alive = true;
    const track = async () => {
      const session = genSessionId();
      if (!alive) return;
      try {
        // Geo enrichment happens server-side from request IP (no CORS dependency)
        await fetch(`${API_BASE}/visitors/track`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page: pathname,
            referrer: document.referrer || '',
            user_agent: navigator.userAgent || '',
            language,
            region,
            screen: `${window.screen.width}x${window.screen.height}`,
            session_id: session
          })
        });
      } catch (err) {
        // Tracking is best-effort; don't disturb UX, but log so devs can diagnose.
        logger.warn('[visitor-track] failed:', err);
      }
    };
    const t = setTimeout(track, 350);
    return () => { alive = false; clearTimeout(t); };
  }, [pathname, region, language]);
};

export default useVisitorTracking;
